import React, { Component } from 'react';
import $ from 'jquery';
import Cookies from 'js-cookie';

export default class TopBar extends Component {

  render() {
    const data = this.props.data;
    let switchLanguage = this.props.switchLanguage;

    $( document ).ready(function() {
      var lang = Cookies.get('language');
      console.log(lang);
      if (lang === "en") {
        $("#english").attr("selected", true);
        $("#korean").attr("selected", false);
      } else if (lang === "kr") {
        $("#korean").attr("selected", true);
        $("#english").attr("selected", false);
      }
    });

    var changelanguage = function(event) {
      if (event.target.value === "english") {
        Cookies.set('language', "en");
        switchLanguage("en");
      } else if (event.target.value === "korean") {
        Cookies.set('language', "kr");
        switchLanguage("kr");
      }
    }

    var toggleSideBar = function() {
      $("#wrapper").toggleClass("enlarged");
      $("#wrapper").toggleClass("forced");
    }

    return (
      <div class="topbar">

          <div class="topbar-left">
              <a href="/dashboard"><div class="logo"></div></a>
          </div>

          <div class="navbar navbar-default" role="navigation">
              <div class="container">

                  <ul class="nav navbar-nav navbar-left">
                      <li>
                          <button onClick={toggleSideBar} class="button-menu-mobile open-left height-control">
                              <i class="fa fa-bars" aria-hidden="true"></i>
                          </button>
                      </li>
                  </ul>

                    <select onChange={changelanguage} id="language_selection">
                      <option value="english" id="english">English</option>
                      <option value="korean" id="korean">한국어</option>
                    </select>

                  <ul class="nav navbar-nav navbar-right">
                      <li class="visuallyhidden">
                        <a href="/logout">
                          <h4>{data.signout}</h4>
                        </a>
                      </li>
                      <li>
                        <a href="/logout" class="right-bar-toggle height-control">
                          <h4><i class="fa fa-sign-out" aria-hidden="true"></i></h4>
                        </a>
                      </li>
                  </ul>

              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/topbar.js